// extracted by mini-css-extract-plugin
module.exports = {"services":"dd31006766--services--2kugZ"};